import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          access_key: '699e1a25-c648-4bc9-9513-1b5dcea93339',
          subject: 'New Contact Form Submission - The Midnight Edits',
          from_name: formData.name,
          email: formData.email,
          message: formData.message,
        })
      });

      const result = await response.json();

      if (result.success) {
        alert('Thank you for your message. We will get back to you soon!');
        setFormData({ name: '', email: '', message: '' });
      } else {
        alert('There was an error sending your message. Please try again or email us directly at info@themidnightedits.com');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('There was an error sending your message. Please email us directly at info@themidnightedits.com');
    }
  };

  return (
    <div id="contact" style={{ background: '#f8f9fa', padding: '80px 0' }}>
      <div className="container">
        <div className="sixteen columns">
          <div className="section-top">
            <div className="line-dark"></div>
            <h1>contact</h1>
            <div className="subtext-top">get in touch with us</div>
            <div className="line-dark1"></div>
          </div>
        </div>
      </div>
      
      <div style={{ maxWidth: '700px', margin: '60px auto', padding: '0 20px' }}>
        <div style={{
          background: '#fff',
          padding: '50px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          border: '1px solid #e8e8e8'
        }}>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '30px' }}>
              <label htmlFor="name" style={{
                display: 'block',
                fontSize: '11px',
                fontWeight: '700',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                color: '#333',
                marginBottom: '12px'
              }}>
                Your Name *
              </label>
              <input
                name="name"
                id="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '14px 16px',
                  border: '1px solid #e8e8e8',
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                  outline: 'none'
                }}
                onFocus={(e) => e.target.style.borderColor = '#d4af37'}
                onBlur={(e) => e.target.style.borderColor = '#e8e8e8'}
              />
            </div>

            <div style={{ marginBottom: '30px' }}>
              <label htmlFor="email" style={{
                display: 'block',
                fontSize: '11px',
                fontWeight: '700',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                color: '#333',
                marginBottom: '12px'
              }}>
                Email Address *
              </label>
              <input
                name="email"
                id="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '14px 16px',
                  border: '1px solid #e8e8e8',
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                  outline: 'none'
                }}
                onFocus={(e) => e.target.style.borderColor = '#d4af37'}
                onBlur={(e) => e.target.style.borderColor = '#e8e8e8'}
              />
            </div>

            <div style={{ marginBottom: '40px' }}>
              <label htmlFor="message" style={{
                display: 'block',
                fontSize: '11px',
                fontWeight: '700',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                color: '#333',
                marginBottom: '12px'
              }}>
                Message
              </label>
              <textarea
                name="message"
                id="message"
                value={formData.message}
                onChange={handleChange}
                rows="6"
                style={{
                  width: '100%',
                  padding: '14px 16px',
                  border: '1px solid #e8e8e8',
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                  outline: 'none',
                  resize: 'vertical',
                  fontFamily: 'inherit'
                }}
                onFocus={(e) => e.target.style.borderColor = '#d4af37'}
                onBlur={(e) => e.target.style.borderColor = '#e8e8e8'}
              />
            </div>

            <button
              type="submit"
              style={{
                width: '100%',
                padding: '16px',
                border: '2px solid #333',
                background: '#333',
                color: '#fff',
                fontSize: '11px',
                fontWeight: '700',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = '#333';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#333';
                e.currentTarget.style.color = '#fff';
              }}
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
